/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
 import { registerBlockType } from '@wordpress/blocks';
 import { __ } from "@wordpress/i18n";

 import classnames from 'classnames';

/**
 * WordPress dependencies
 */
import {
	InnerBlocks,
	useBlockProps,
	useInnerBlocksProps,
	store as blockEditorStore,
} from '@wordpress/block-editor';

import { useSelect, useDispatch } from '@wordpress/data';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
 import "./editor.scss";

 
import metadata from './block.json';

 
 /**
  * Every block starts by registering a new block type definition.
  *
  * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
  */
 registerBlockType( metadata.name, {

	 edit: ({
        attributes: {
            templateLock = false,
            allowedBlocks,
        },
        setAttributes,
        clientId,
    } ) => {

        const classes = classnames( 'splide__slide', {
        } );

        const blockProps = useBlockProps( {
            className: classes,
        } );

        const { columnsIds, hasChildBlocks, rootClientId } = useSelect(
            ( select ) => {
                const { getBlockOrder, getBlockRootClientId } = select(
                    blockEditorStore
                );
    
                const rootId = getBlockRootClientId( clientId );
    
                return {
                    hasChildBlocks: getBlockOrder( clientId ).length > 0,
                    rootClientId: rootId,
                    columnsIds: getBlockOrder( rootId ),
                };
            },
            [ clientId ]
        );

        const innerBlocksProps = useInnerBlocksProps(
            { ...blockProps },
            {
                templateLock,
                allowedBlocks,
                renderAppender: hasChildBlocks
                    ? undefined
                    : InnerBlocks.ButtonBlockAppender,
            }
        );
         return (
            <li { ...innerBlocksProps } />
         );
     },
 
	  save: () => {
        
        const classes = classnames('splide__slide');
        const blockProps = useBlockProps.save( {
            className: classes, 
        } );
        const innerBlocksProps = useInnerBlocksProps.save( blockProps );
    
        return <li { ...innerBlocksProps } />;
    },
 } );
